import * as React from "react";
import styled from "styled-components";

import PopoverContainer from "./PopoverContainer";

interface Props {
  className?: string;
  render: React.ReactNode;
  children: React.ReactNode;
  openDelay?: number;
  closeDelay?: number;
}

class Tooltip extends React.PureComponent<Props> {
  public static defaultProps: Partial<Props> = {
    openDelay: 600,
    closeDelay: 700,
  };
  public render() {
    const { render, className, children, openDelay, closeDelay } = this.props;
    return (
      <PopoverContainer
        render={({ left, top, onOpen, onClose }) => {
          const onCloseDelayed = () => onClose({ delay: 200 });
          return (
            <Tip onMouseEnter={onOpen} onMouseLeave={onCloseDelayed} style={{ left, top }}>
              {render}
            </Tip>
          );
        }}
      >
        {({ setRef, onOpen, onClose, isOpen }) => {
          const onOpenDelayed = () => onOpen({ delay: openDelay });
          const onCloseDelayed = () => onClose({ delay: closeDelay });
          return (
            <Wrapper
              innerRef={setRef}
              onMouseEnter={onOpenDelayed}
              onMouseLeave={onCloseDelayed}
              onTouchEnd={isOpen ? onCloseDelayed : onOpenDelayed}
              className={className}
            >
              {children}
            </Wrapper>
          );
        }}
      </PopoverContainer>
    );
  }
}

const Tip = styled.div`
  position: absolute;
  transform: translate(0, -100%);
  max-width: 210px;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 10px;
`;

const Wrapper = styled.span`
  position: relative;
  display: inline-block;
`;

export default Tooltip;



// WEBPACK FOOTER //
// ./frontend/src/common/components/popover/Tooltip.tsx